import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'; 

@Injectable({
  providedIn: 'root'
})
export class ToastService {

	isMaintenanceMode:any = false;

	constructor(
		public sanitizer: DomSanitizer
	) { }

	/**
	 * site loader gif is visible
	 */
	loader: boolean = false;

	/**
	 * sample entry of toast
	 * {'msg': 'test', 'type': 'success'}
	 */
	list: any = [];
	pageCover: boolean = false;

	/**
	 * add a new toast
	 * @param message str the message to be added
	 */
	add(message: any, type: any = 'success', timeout: number = 8000) {
		if(message){
			if(!this.isMaintenanceMode){
				let m = {
					msg: message,
					type: type
				};
				m.msg = this.sanitizer.bypassSecurityTrustHtml(m.msg);
				
				this.list.push(m);
		
				if(timeout){
					setTimeout(f =>{
						this.clear(0)
					}, timeout);
				}
			}
			else {
				this.clearAll();
			}
		}
	}
 
	/**
	 * remove specific toast in array
	 * @param key number the key of the toast in array
	 */
	clear(key) {
		this.list.splice(key, 1);
	}

	/**
	 * clear all toast
	 */
	clearAll() {
		this.list = [];
	}

	setLoader(show:boolean = true){
		this.loader = show;
	}

	/** 
	 * start:  quick order page for add multiple items to cart
	 */
	addingTocart:any = {
		fieldItemsCount: 0, /** this is the total count of items */
		itemsCount: 0, /** this is the total count of the added items */
		inPercent: 0,/** progress percentage */
		currentUploadingFileKey: 0, /** the current item attchement being uploaded */
		uploadProgress: 0, /** this is the current uploaded file */
		uploadingFileName: '' 
	}
	/**
	 * 
	 * @param fieldItems 
	 * @param items 
	 */
	setAddingToCartItems(items:any){
		items.forEach(item => {
			this.addingTocart.fieldItemsCount++;
		});
	}

	setItemAdded(itemCount:number = 1){
		this.addingTocart.itemsCount += itemCount;
		if(this.addingTocart.itemsCount){
			this.addingTocart.inPercent = this.addingTocart.itemsCount / this.addingTocart.fieldItemsCount * 100;
			this.addingTocart.currentUploadingFileKey = 0;
			this.addingTocart.uploadProgress = 0;
			this.addingTocart.uploadingFileName = '';
		}
	}

	closeToastMessage(){
		this.addingTocart.fieldItemsCount = 0;
		this.addingTocart.inPercent = 0;
		this.addingTocart.itemsCount = 0;
		this.addingTocart.currentUploadingFileKey = 0;
		this.addingTocart.uploadProgress = 0;
		this.addingTocart.uploadingFileName = '';
	}

	/** 
	 * end: quick order page for add multiple items to cart
	 */


	/**
	 * start: push notification from magento via socket server
	 */
	// initPush(data:any){
	// 	try {
	// 		let type:string = data['type'];
	// 		switch (type) {
	// 			case 'maintenance_flag_message': 
	// 				this.add(data['data']['message'], 'warning');
	// 				break;
	// 			default:
	// 				break;
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 		/** do nothing for now */
	// 	}
	// }
	/**
	 * end: push notification from magento via socket server
	 */

	setPageCover(show:boolean = true){
		this.pageCover = show;
	}
}
